import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Chart, ChartOptions } from 'chart.js';
import { DashboardWidgetBase } from '../dashboard-widgets.base';
import { RiskDistributionParameterType } from '../riskdistribution-parameter-type';
import { WidgetDataType } from '../widget-data-type';
import { WidgetParametersService } from '../widget-parameters/widget-parameters.service';
import { BarData } from './BarData';
import { BarDataset } from './BarDataset';


@Component({
  selector: 'hb-bar',
  templateUrl: 'bar.component.html',
  styleUrls: ['bar.component.scss'],
})
export class BarComponent extends DashboardWidgetBase implements OnInit, AfterViewChecked, OnChanges, AfterViewInit {
  public barData: BarData;
  public barChart: Chart;

  @Input() hideDragAndDrop = false;
  @Input() hideCog = false;
  @Input() hideTitleEdit = false;
  @Input() showTableOption = true;

  public cuColor: string;
  @Input() public colour: string;

  @Input() public data;

  constructor(router: Router, private widgetParametersService: WidgetParametersService, private changeDetector: ChangeDetectorRef) {
    super(router);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if ((changes.colour || changes.data) && this.colour && this.data) {
      this.initChartData();
    }
  }

  public ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  private initChartData() {
    this.barData = new BarData();
    this.barData.datasets.push(new BarDataset());
    const data = this.data;

    this.barData.labels = data.Labels;

    for (let i = 0; i < data.Labels.length; i++) {
      this.barData.labels[i] = data.Labels[i] ? data.Labels[i] : 'None';
    }

    this.barData.datasets[0].data = data.Dataset.Data;

    if (this.displayLegend()) {
      this.barData.datasets[0].label = data.Dataset.Label;
    }

    const riskDistributionParameter = this.widgetParametersService.getRiskDistributionParameter(this.dashboardWidget);

    if (
      this.dashboardWidget.widget.widgetDataType === WidgetDataType.RiskDistribution &&
      riskDistributionParameter &&
      riskDistributionParameter === RiskDistributionParameterType.RiskBand
    ) {
      this.barData.datasets[0].backgroundColor = data.Dataset.BackgroundColor;
    } else {
      data.Dataset.Data.forEach(d => {
        this.barData.datasets[0].backgroundColor.push(this.colour);
      });
    }

    this.drawChart();
  }

  private drawChart() {
    const chartCanvas = document.getElementById(this.canvasId) as HTMLCanvasElement;

    if (!this.barData || !this.widgetId || !chartCanvas) {
      return;
    }

    const isHorizontalBar = this.isHorizontalBarChart();
    const xCallback =  this.xAxesCallback;
    const yCallback =  this.yAxesCallback;


    const options: ChartOptions<'bar'> = {
      plugins:{
        legend: {
          display: this.displayLegend(),
        },
        tooltip: {
          mode: 'index',
          intersect: false,
        },
      },
      hover: {
        mode: 'index',
        intersect: false,
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          display: true,
          beginAtZero: isHorizontalBar,
          ticks: {
            autoSkip: false,
            stepSize: 1,
            callback(value, index): string | number {
              const curLabel = typeof value === 'number' ? this.getLabelForValue(value) : '';

              if(!isHorizontalBar){
                return xCallback(curLabel);
              }else {return yCallback(value);}

            },
          },
        },
        y: {
          display: true,
          beginAtZero: true,
          ticks: {
            callback(value, index): string | number {
              const curLabel = typeof value === 'number' ? this.getLabelForValue(value) : '';

              if(isHorizontalBar){
                return xCallback(curLabel);
              }else {return yCallback(value);}
            },
          },
        },
      },
    };

    if (isHorizontalBar) {
      options.indexAxis= 'y';
    }

    const datasets = this.barData.datasets.map(dSets=>({...dSets, barPercentage: 0.6}));

    // Destroy the canvas before recreating
    const existingChart: Chart = Chart.getChart(chartCanvas);
    if(existingChart){
      existingChart.destroy();
    }

    this.barChart = new Chart(chartCanvas, {
      type: 'bar',
      data: {
        labels: this.barData.labels,
        datasets,
      },
      options,
    });
  }

  public ngOnInit() {}

  public ngAfterViewInit(): void {
    setTimeout(() => this.drawChart());
  }

  private isHorizontalBarChart(): boolean {
    if (this.dashboardWidget && this.dashboardWidget.widget) {
      const {
        widget: { widgetDataType },
      } = this.dashboardWidget;

      return widgetDataType === WidgetDataType.PlannedMaintenanceImprovements;
    }

    return false;
  }
}
